const publicImage = (filename: string | undefined) => {
    return `${process.env.PUBLIC_URL}/assets/images/${filename}`;
}

export default publicImage;
